// ----------------------------------------------------------------------------
// Quantity Selector Extension (Validate Inventory Quantity Limits)
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import Debug from 'scripts/libs/debug';

// -------------------------------------
// Functionality
// -------------------------------------

var validationRules = {
  available: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant;
      return ((_itemData$variant = itemData.variant) === null || _itemData$variant === void 0 ? void 0 : _itemData$variant.available) || false;
    },
    condition_callback: (current_quantity, available) => available,
    error_message: (current_quantity, available, itemData) => translate('Sorry, this item is not available.', 'quantity.error.not_available', {
      QUANTITY: current_quantity,
      itemData
    })
  }
};
iamotaEventHandler.subscribe('iamForm:quantity:validation:init', _ref => {
  var iamFormElement = _ref.iamFormElement,
    validator = _ref.validator;
  var quantityInput = iamFormElement;
  var _loop = function _loop(ruleType) {
    var rule = validationRules[ruleType];
    validator.addField(quantityInput.control, [{
      validator: (current_quantity, fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        var result = condition_value === null || rule.condition_callback(parseInt(current_quantity, 10), condition_value, itemData);
        Debug.extreme("Validating Quantity [".concat(ruleType, "]: ").concat(current_quantity, " vs. ").concat(condition_value, " => ").concat(result ? Debug.colors.bgGreen('Valid') : Debug.colors.bgRed('Invalid')), {
          current_quantity,
          condition_value,
          result,
          itemData,
          fields
        });
        return result;
      },
      errorMessage: (current_quantity, fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        return rule.error_message(current_quantity, condition_value, itemData);
      }
    }], {
      errorsContainer: quantityInput.errorContainer
    });
  };
  for (var ruleType in validationRules) {
    _loop(ruleType);
  }
}, {
  source: "quantity-input--available.js"
});